// Put your Javascript here - You can use ES2015 Javascript, because we use Webpack with Babel
import * as helper from './../../../../../VX/View/Assets/Js/helper';
import { handleValidation, isFilled, handleEmailError, handleusernameError, STATUS_EMAIL, STATUS_USERNAME} from "./../../../Assets/HandleValidation";

require('./../Sass/base.scss');

// Require babel polyfill before anything else so stupid IE can handle modern stuff like Symbols etc.
if (!(global as any)._babelPolyfill) {
	require('babel-polyfill');
}

helper.onDocumentLoaded(() => {
	const content = helper.$('#content');
	const womenCounter = helper.$('#counter');
	const teaserCounter = helper.$('#teasercounter');
	const buttons = helper.$('#button, .interact-item-link');
	const emailValidationUrl = helper.getData(content, "emailvalidationurl");
	const usernameValidationUrl = helper.getData(content, "usernamevalidationurl");
	
	const inputUsername = helper.$("#username");
	const inputEmail = helper.$("#email");
	const suggestions = helper.$("#suggestions") as HTMLElement;
	const error_user = helper.$("#error_user") as HTMLElement;
	const error_email = helper.$("#error_email") as HTMLElement;
	const errors = {username: true, email: true};
	const submitButton = helper.$("#signup");
	const controller = new AbortController();

	function handleSuggestion (e: Element) {
		inputUsername.value = e.textContent;
		suggestions.style.display = "none";
	}

	window.addEventListener('keydown',function(e) {
        if (e.key =='Enter' ) {
            e.preventDefault();
        }
    }, true);

	const makeList = (list: string[]) => {
		const ul = document.createElement("ul");
		const container = document.createElement("div");
		container.classList.add("suggestions_wrapper");
		const h6 = document.createElement("h6");
		let items;
		// sometimes the api returns an object instead of an array XD
		if (Array.isArray(list)){
			items = list.map((item) => {
				const li = document.createElement("li");
				li.classList.add("suggested_username");
				li.textContent = item;
				return li;
			});	
		}else{
			items = Object.keys(list).map((item) => {
				const li = document.createElement("li");
				li.classList.add("suggested_username");
				li.textContent = list[item];
				return li;
			})
		}
		h6.textContent = "Username Suggestions";
		ul.append(...items);
		container.append(ul);
		container.prepend(h6);
		return container;
	}
	const itemSuggestionsListeners = () =>{

	const items = document.querySelectorAll(".suggested_username");
		items.forEach((item) => {
			helper.addEventListener(item, "click", (e) => {
				handleSuggestion(item);
				error_user.innerHTML = "";
				error_user.style.display = "none";
				errors.username = false;
				setSubmintButtonState();
			});
		});
	}

	function validateUsername(){
		if(isFilled(inputUsername.value)) {
			const data = handleValidation(usernameValidationUrl, inputUsername.value, controller);
			data.then((res) => {
				if(res.data?.userNameSuggestions) {
					suggestions.innerHTML = makeList(res.data.userNameSuggestions).outerHTML;
					suggestions.style.display = "block";
					itemSuggestionsListeners();
					errors.username = true;
					error_user.innerHTML = handleusernameError(res.data.status);
					error_user.style.display = "block";					
					setSubmintButtonState();
				}else{
					if(res.data.status === (STATUS_USERNAME.OK || STATUS_USERNAME.OKE)) {
						console.log(res.data.status);
						errors.username = false;
						error_user.innerHTML = "";
						error_user.style.display = "none";
						suggestions.style.display = "none";
						setSubmintButtonState();
					}
				}
			});
		}
	}

	helper.addEventListener(inputUsername, "input", validateUsername);

	function setSubmintButtonState() {
		submitButton.disabled = (errors.email || errors.username);
	}

	function validateEmail(){
		const data = handleValidation(emailValidationUrl, inputEmail.value, controller);
		data.then((res) => {
			if(res.data.status === (STATUS_EMAIL.OK || STATUS_EMAIL.OKE)) {
				errors.email = false;
				error_email.innerHTML = "";
				error_email.style.display = "none";
				setSubmintButtonState();
			}else{
				error_email.innerHTML = handleEmailError(res.data.status);
				errors.email = true;
				error_email.style.display = "block";
				setSubmintButtonState();
			}
		})
	}
	helper.addEventListener(inputEmail, "input", validateEmail);

	validateUsername();
	validateEmail();

	let womenCount = 1324;
	let timer = 5 * 60;

	for (let i = 0; i < buttons.length; i++) {
		const button = buttons[i];
		helper.addClickListener(button, (e:MouseEvent) => {
			e.preventDefault();
			helper.show(helper.$('#anmeldung'));
		})
	}

	setInterval(() => {
		womenCount += Math.round(Math.random() * 4) + 1;
		womenCounter.innerText = Intl.NumberFormat('de-DE').format(womenCount);
	}, 2000)

	setInterval(() => {
		timer -= 1;
		if (timer < 0) {
			timer = 0;
		}

		const minutes = Math.floor(timer / 60);
		const seconds = Intl.NumberFormat('de-DE', {minimumIntegerDigits: 2}).format(timer % 60);

		teaserCounter.innerText = `${minutes}:${seconds} Min.`;
	}, 1000);
})
